import React, { useEffect, useState } from 'react';

import { getCountry } from '@/services/Address/request';
import { Country } from '@/services/Address/types';

import SimpleSelect, { ISelectProps, SelectOption } from './SimpleSelect';

type Props = Omit<ISelectProps, 'options' | 'label'> & {
  label?: string;
  labelClassName?: string;
  valueIsFullName?: boolean;
};

const CountrySelect: React.FC<Props> = ({
  id,
  label = 'País',
  placeholder = 'Selecione',
  disabled = false,
  formik,
  labelClassName,
  valueIsFullName = true,
  required,
  error = false,
  disableHelperText = false,
  disableRequireSymbol = false,
  // sem default: 'BR' não casa com nenhuma option (os values são o nome do
  // país) e só servia pra esconder a option vazia, fazendo o campo exibir
  // "Brasil" — o primeiro país da lista — mesmo com o valor vazio.
  defaultSelected,
}) => {
  const [countries, setCountries] = useState<SelectOption[]>([]);

  const getData = async () => {
    const allCountries = await getCountry();
    if (valueIsFullName) {
      setCountries(
        allCountries.map<SelectOption>((item: Country) => ({
          value: item.name,
          valueLabel: item.name,
        })),
      );
    } else {
      setCountries(
        allCountries.map<SelectOption>((item: Country) => ({
          value: item.acronym,
          valueLabel: item.name,
        })),
      );
    }
  };

  useEffect(() => {
    getData();
    return () => {};
  }, []);

  return (
    <SimpleSelect
      label={label}
      id={id}
      placeholder={placeholder}
      options={countries}
      formik={formik}
      disabled={disabled}
      required={required}
      labelClassName={labelClassName}
      defaultSelected={defaultSelected}
      error={error}
      disableHelperText={disableHelperText}
      disableRequireSymbol={disableRequireSymbol}
    />
  );
};

export default CountrySelect;
